<script setup>
import ApikomContentForm from '@frontJs/components/forms/projectManagement/seo/ApikomContentForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, websiteVariants, seoApikomContent } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    websiteVariants: {
        type: Array,
        required: true,
    },
    seoApikomContent: {
        type: [Object, null],
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="seoApikomContent">
            Mettre à jour le contenu Apikom #{{ seoApikomContent.id }} - SEO/GEO
            - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un contenu Apikom - SEO/GEO - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="seoApikomContent" :tenant-name="tenant.name">
        Gestion de projet - SEO/GEO - Mettre à jour le contenu Apikom #{{
            seoApikomContent.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEO/GEO - Créer un contenu Apikom
    </PageTitle>

    <ApikomContentForm
        :tenant="tenant"
        :website-variants="websiteVariants"
        :seo-apikom-content="seoApikomContent"
    />
</template>
